import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const Academy = () => {
  const programs = [
    {
      title: "Youth Development",
      description: "Specialized programs for young golfers aged 6-18, focusing on fundamentals, technique, and competitive skills.",
      imageUrl: "https://images.squarespace-cdn.com/content/v1/5bd9eaf070e802753aaeaf18/1672867343644-WZQZU6LY50BXDDCZJYI2/unsplash-image-aGlpdQ2Yolk.jpg",
      features: ["Age-appropriate training", "School integration", "Tournament preparation", "Scholarship opportunities"]
    },
    {
      title: "Women in Golf",
      description: "Dedicated programs to increase female participation in golf with supportive coaching and community building.",
      imageUrl: "https://images.unsplash.com/photo-1571158096385-a56767c1f57c?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8ZHJpdmluZyUyMHJhbmdlfGVufDB8fDB8fHww",
      features: ["Women-only sessions", "Beginner-friendly approach", "Networking events", "Professional development"]
    },
    {
      title: "Beginner to Pro Pathway",
      description: "Structured progression from complete beginner to professional levels with clear milestones and achievements.",
      imageUrl: "https://images.unsplash.com/photo-1535131749006-b7f58c99034b?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      features: ["Step-by-step curriculum", "Regular assessments", "Tournament participation", "Career guidance"]
    }
  ];

  const coaches = [
    {
      name: "Rajiv Sharma",
      role: "Head Professional",
      experience: "15+ years PGA certified",
      specialty: "Swing Mechanics & Tournament Strategy"
    },
    {
      name: "Priya Mehta",
      role: "Performance Coach",
      experience: "8 years LPGA experience",
      specialty: "Short Game & Mental Training"
    },
    {
      name: "Arjun Patel",
      role: "Youth Development Director",
      experience: "10 years junior coaching",
      specialty: "Junior Golf & Talent Identification"
    }
  ];

  return (
    <>
      {/* Hero Section */}
      <section style={{
        height: '60vh',
        background: 'linear-gradient(rgba(31, 61, 43, 0.8), rgba(31, 61, 43, 0.9)), url(https://images.unsplash.com/photo-1670254494696-909c4e429575?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8ZHJpdmluZyUyMHJhbmdlfGVufDB8fDB8fHww) center/cover no-repeat',
        display: 'flex',
        alignItems: 'center'
      }}>
        <Container>
          <Row>
            <Col lg={8} className="text-white">
              <h1 className="display-4 fw-bold mb-4" style={{ color: "#B59A5A" }}>Golf Academy</h1>
              <p className="lead" style={{ opacity: 0.9 }}>
                Nurturing raw talent and producing world-class golfers through systematic coaching
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Academy Philosophy */}
      <section className="section-padding">
        <Container>
          <Row className="align-items-center mb-5">
            <Col lg={6} className="mb-5 mb-lg-0">
              <h2 className="mb-4">Our Coaching Philosophy</h2>
              <div className="mb-4">
                <p style={{ color: '#666', fontSize: '1.1rem' }}>
                  At Golf4International Academy, we've moved away from traditional 'assembly line' coaching
                  to a systematic approach that treats each golfer as a unique individual.
                </p>
              </div>

              <div className="d-flex mb-3">
                <div style={{ marginRight: '2rem' }}>
                  <h3 className="h2 mb-0" style={{ color: 'var(--muted-gold)' }}>Personalized</h3>
                  <p className="mb-0" style={{ color: '#666' }}>Coaching</p>
                </div>
                <div style={{ marginRight: '2rem' }}>
                  <h3 className="h2 mb-0" style={{ color: 'var(--muted-gold)' }}>Systematic</h3>
                  <p className="mb-0" style={{ color: '#666' }}>Development</p>
                </div>
                <div>
                  <h3 className="h2 mb-0" style={{ color: 'var(--muted-gold)' }}>Holistic</h3>
                  <p className="mb-0" style={{ color: '#666' }}>Approach</p>
                </div>
              </div>
            </Col>

            <Col lg={6}>
              <div style={{
                height: '400px',
                background: 'url(https://images.unsplash.com/photo-1587174486073-36dab6c4c0ae?ixlib=rb-4.0.3&auto=format&fit=crop&w-800&q=80) center/cover no-repeat',
                borderRadius: '12px'
              }} />
            </Col>
          </Row>

          {/* Four Pillars */}
          <Row className="g-4 mb-5">
            <Col md={3}>
              <div className="p-4 bg-soft-sage rounded text-center h-100">
                <div style={{
                  width: '60px',
                  height: '60px',
                  backgroundColor: 'var(--muted-gold)',
                  color: 'white',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '1.5rem',
                  margin: '0 auto 1rem'
                }}>
                  1
                </div>
                <h4 className="h5 mb-3">Technical Excellence</h4>
                <p style={{ color: '#666', fontSize: '0.9rem' }}>
                  Perfect fundamentals through biomechanical analysis and video feedback
                </p>
              </div>
            </Col>

            <Col md={3}>
              <div className="p-4 bg-soft-sage rounded text-center h-100">
                <div style={{
                  width: '60px',
                  height: '60px',
                  backgroundColor: 'var(--muted-gold)',
                  color: 'white',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '1.5rem',
                  margin: '0 auto 1rem'
                }}>
                  2
                </div>
                <h4 className="h5 mb-3">Physical Conditioning</h4>
                <p style={{ color: '#666', fontSize: '0.9rem' }}>
                  Golf-specific fitness to increase power, flexibility, and prevent injuries
                </p>
              </div>
            </Col>

            <Col md={3}>
              <div className="p-4 bg-soft-sage rounded text-center h-100">
                <div style={{
                  width: '60px',
                  height: '60px',
                  backgroundColor: 'var(--muted-gold)',
                  color: 'white',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '1.5rem',
                  margin: '0 auto 1rem'
                }}>
                  3
                </div>
                <h4 className="h5 mb-3">Mental Game</h4>
                <p style={{ color: '#666', fontSize: '0.9rem' }}>
                  Focus techniques, pressure management, and competition mindset
                </p>
              </div>
            </Col>

            <Col md={3}>
              <div className="p-4 bg-soft-sage rounded text-center h-100">
                <div style={{
                  width: '60px',
                  height: '60px',
                  backgroundColor: 'var(--muted-gold)',
                  color: 'white',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '1.5rem',
                  margin: '0 auto 1rem'
                }}>
                  4
                </div>
                <h4 className="h5 mb-3">Tournament Prep</h4>
                <p style={{ color: '#666', fontSize: '0.9rem' }}>
                  Course strategy, equipment optimization, and competition logistics
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Programs Section */}
      <section className="section-padding bg-soft-sage">
        <Container>
          <Row className="mb-5">
            <Col lg={8}>
              <h2 className="mb-4">Programs for Every Golfer</h2>
              <p style={{ color: '#666' }}>
                From complete beginners to aspiring professionals, we have programs designed for every skill level and age group.
              </p>
            </Col>
          </Row>

          <Row className="g-4">
            {programs.map((program, index) => (
              <Col lg={4} key={index}>
                <div className="card-modern h-100">
                  <div
                    style={{
                      height: '200px',
                      background: `url(${program.imageUrl}) center/cover no-repeat`
                    }}
                  />
                  <div className="p-4">
                    <h3 className="h4 mb-3">{program.title}</h3>
                    <p style={{ color: '#666' }} className="mb-4">
                      {program.description}
                    </p>
                    <ul style={{ color: '#666', fontSize: '0.9rem' }}>
                      {program.features.map((feature, idx) => (
                        <li key={idx} className="mb-2">{feature}</li>
                      ))}
                    </ul>
                    <button className="btn-gold mt-3 w-100">Learn More</button>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Coaches Section */}
      <section className="section-padding">
        <Container>
          <Row className="mb-5">
            <Col lg={8}>
              <h2 className="mb-4">Meet Our Coaches</h2>
              <p style={{ color: '#666' }}>
                Our team of certified professionals brings decades of experience and a passion for developing talent.
              </p>
            </Col>
          </Row>

          <Row className="g-4">
            {coaches.map((coach, index) => (
              <Col md={4} key={index}>
                <div className="p-4 border rounded text-center h-100">
                  <div style={{
                    width: '100px',
                    height: '100px',
                    backgroundColor: 'var(--soft-sage)',
                    borderRadius: '50%',
                    margin: '0 auto 1.5rem',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    <span style={{ fontSize: '2rem' }}>👨‍🏫</span>
                  </div>
                  <h3 className="h5 mb-2">{coach.name}</h3>
                  <p className="text-muted mb-2">{coach.role}</p>
                  <p className="small text-muted mb-3">{coach.experience}</p>
                  <p style={{ color: 'var(--muted-gold)' }} className="small">
                    {coach.specialty}
                  </p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Academy;